/* Nerm Nugs coming-soon signup popup — ripndip.com
   Loaded with `defer` by snippets/nerm-nugs-popup.liquid. Runs INSTEAD of the Pocket Tee Popup while
   settings.nn_popup_enabled is on (sections/pocket-popup.liquid renders nothing then), so only one signup
   popup can ever appear in a session.

   Shares the Pocket Tee Popup's audience rules and storage keys. The rules are ported from
   assets/pocket-popup-klaviyo-gate.js, which stays untouched, so both popups read one rule set:
     rnd_pp_pv / rnd_pp_entry   pageviews this session, and whether the session ENTERED on a product page
     rnd_pp_owned               ever arrived from an email/SMS link
     rnd_buyer                  completed a checkout (written by the customer-events pixel)
     rnd_pocket_popup_kl_known  Klaviyo said "identified" once on this browser
     rnd_pocket_popup           the Pocket Tee Popup's own 7/30-day cookie, honoured here too
     nn_popup_v1                this popup's caps: shownAt / dismissedAt (7 d) / signedUpAt (30 d)

   Analytics go where the Pocket Tee Popup's go, with the same pp_* vocabulary and
   variant = "nerm-nugs-coming-soon" so the HQ card can split the two:
     events.ripndip.com/pp (sendBeacon), PostHog, Shopify.analytics.publish('pocket_popup'),
     cart attributes _pp_exposed / _pp_signup, Klaviyo identify + "Nerm Nugs Popup Signup".

   Performance contract
   - Ineligible visitor  → returns after a few cheap checks. No listeners, no CSS, no images.
   - Eligible visitor    → one passive scroll listener. CSS + template + images load ~3 s before the trigger.
   - Popup open          → keychain physics runs on requestAnimationFrame only while open AND the tab is visible.
   - Popup closed        → loop stopped, scroll lock and cookie banner released.

   QA on a preview theme (debug logging is off on the published theme):
     ?nn_popup=1      open now, skipping gating and the delay
     ?nn_popup=reset  clear this popup's caps and the Klaviyo "known" flag, skip the audience and page
                      rules for this pageview; the scroll trigger still applies
     ?nn_popup=debug  log every decision to the console

   The pure helpers are exported for `node --test` (perf/tests/nerm-nugs-popup.test.mjs). */
(function (globalRoot, factory) {
  const api = factory();
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  else globalRoot.NermNugsPopup = api;
})(typeof self !== "undefined" ? self : this, function () {
  "use strict";

  const VERSION = "nn-v1";
  const VARIANT = "nerm-nugs-coming-soon";
  const COLLECTOR = "https://events.ripndip.com/pp";
  const STATE_KEY = "nn_popup_v1";
  const KNOWN_KEY = "rnd_pocket_popup_kl_known";
  const PP_COOKIE = "rnd_pocket_popup";
  const SS = { pv: "rnd_pp_pv", entry: "rnd_pp_entry", sid: "rnd_pp_sid", landing: "rnd_pp_landing", decided: "rnd_pp_decided" };
  const LS = { owned: "rnd_pp_owned", buyer: "rnd_buyer", vid: "rnd_pp_vid" };
  const PRODUCT_ENTRY_MIN_PAGEVIEWS = 3;
  const PROBE_MS = 1200;

  /* ================= pure helpers (ported from the Pocket Tee Popup's gate and engine) ================= */
  function readCookie(cookie, name) {
    const m = String(cookie || "").match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? m[1] : "";
  }
  /* __kla_id is base64 of a small JSON blob. Keyed on the contact details inside it and deliberately NOT
     on $exchange_id: Klaviyo mints an exchange id for anonymous browsers too. */
  function cookieKnown(raw, b64decode) {
    if (!raw) return false;
    try {
      let txt = String(raw);
      try { txt = decodeURIComponent(txt); } catch {}
      const obj = JSON.parse(b64decode ? b64decode(txt) : txt);
      return !!(obj && typeof obj === "object" && (obj.$email || obj.$phone_number));
    } catch { return false; }
  }
  function linkKnown(search) {
    const s = String(search || "").toLowerCase();
    return /[?&]_kx=/.test(s) || /[?&]utm_source=klaviyo(?:[&#]|$)/.test(s);
  }
  /* Email and SMS clicks from any provider. Only a subscriber can be sent one. */
  const OWNED_RE = /[?&](?:_kx=|utm_medium=(?:email|sms|text|push)(?:[&#]|$)|utm_source=(?:klaviyo|attentive|postscript|sms)(?:[&#]|$))/;
  function ownedChannelLanding(search) { return OWNED_RE.test(String(search || "").toLowerCase()); }
  /* Pages where a signup interruption costs more than it earns. */
  function blockedPage(path, pageType) {
    const p = String(path || "").toLowerCase(), t = String(pageType || "").toLowerCase();
    if (t === "cart" || /\/(?:cart|account|checkouts?)(?:\/|$)/.test(p)) return "cart-or-account";
    if (t === "product" || /\/products\//.test(p)) return "product";
    return "";
  }
  /* A session that entered on a product page waits for a later pageview. */
  function entryAllows(entry, pageviews, min) {
    return entry !== "product" || pageviews >= (min || PRODUCT_ENTRY_MIN_PAGEVIEWS);
  }
  function drawerOpen(className) { return /(?:^|\s)(?:js-drawer-open|modal-open)(?:\s|-|$)/.test(String(className || "")); }
  /* The Pocket Tee Popup's cookie holds a ms timestamp: still in the future = that popup owns this browser. */
  function pocketSuppressedUntil(cookie) { return parseInt(readCookie(cookie, PP_COOKIE), 10) || 0; }
  /* This popup's own caps. */
  function capped(state, now, dismissDays, signupDays) {
    const day = 864e5, s = state || {};
    if (s.signedUpAt && now - s.signedUpAt < signupDays * day) return "signed-up";
    if (s.dismissedAt && now - s.dismissedAt < dismissDays * day) return "dismissed";
    return "";
  }
  /* US mobile numbers only: the SMS step carries a US TCPA disclosure and Canada is excluded. Same rule as
     the Pocket Tee Popup. NANP area and exchange codes never begin with 0 or 1. */
  const NON_US_NANP = {
    "204":1,"226":1,"236":1,"249":1,"250":1,"263":1,"289":1,"306":1,"343":1,"354":1,
    "365":1,"367":1,"368":1,"382":1,"387":1,"403":1,"416":1,"418":1,"428":1,"431":1,
    "437":1,"438":1,"450":1,"468":1,"474":1,"506":1,"514":1,"519":1,"548":1,"579":1,
    "581":1,"584":1,"587":1,"600":1,"604":1,"613":1,"622":1,"639":1,"647":1,"672":1,
    "683":1,"705":1,"709":1,"742":1,"753":1,"778":1,"780":1,"782":1,"807":1,"819":1,
    "825":1,"867":1,"873":1,"879":1,"902":1,"905":1,
    "242":1,"246":1,"264":1,"268":1,"284":1,"345":1,"441":1,"473":1,"649":1,"658":1,
    "664":1,"721":1,"758":1,"767":1,"784":1,"809":1,"829":1,"849":1,"868":1,"869":1,
    "876":1
  };
  function toE164US(raw) {
    if (typeof raw !== "string") return null;
    let d = raw.replace(/[^0-9]/g, "");
    if (d.length === 11) { if (d.charAt(0) !== "1") return null; d = d.slice(1); }
    if (d.length !== 10) return null;
    if (d.charAt(0) === "0" || d.charAt(0) === "1") return null;
    if (d.charAt(3) === "0" || d.charAt(3) === "1") return null;
    if (NON_US_NANP[d.slice(0, 3)]) return null;
    return "+1" + d;
  }
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function isValidEmail(v) { return typeof v === "string" && EMAIL_RE.test(v.trim()); }
  /* 409 = already on the list, which is a success from the visitor's side. Only 422 is a bad address; a 400 is
     far more likely a bad list id setting than a typo, so it falls through to 'error'. */
  function classifyResponse(status) {
    if (status >= 200 && status < 300) return "success";
    if (status === 409) return "success";
    if (status === 422) return "invalid";
    if (status === 429) return "retry";
    return "error";
  }
  /* Two-call pattern: the phone step sends SMS consent alone; the email step sends email consent and carries
     the same phone so Klaviyo merges the profile. Email consent is never sent twice.
     The client endpoint requires a list on every call. The email step always uses the main list. The phone
     step uses the optional SMS list when one is set, otherwise the main list. Why: "Added to List" fires
     once per profile and the WELCOME SERIES (the 10% email) is list-triggered, so if the phone step adds the
     profile to the main list first, that flow runs with no email address and cannot run again when the email
     arrives. A separate SMS list keeps the main-list add for the email step. SMS WELCOME is metric-triggered
     (Subscribed to Text Messaging Marketing), so SMS consent starts it whichever list is used. */
  function subscribePayload(profile, listId, customSource, smsListId) {
    const subs = {};
    if (profile.email) subs.email = { marketing: { consent: "SUBSCRIBED" } };
    else if (profile.phone_number) subs.sms = { marketing: { consent: "SUBSCRIBED" } };
    const attrs = { subscriptions: subs };
    if (profile.email) attrs.email = String(profile.email).trim();
    if (profile.phone_number) attrs.phone_number = profile.phone_number;
    const list = profile.email ? listId : (smsListId || listId);
    return { data: { type: "subscription",
      attributes: { custom_source: customSource, profile: { data: { type: "profile", attributes: attrs } } },
      relationships: { list: { data: { type: "list", id: list } } } } };
  }
  /* Attribution fields out of a landing URL. */
  function parseLanding(search, referrer) {
    const out = { utm_source: "", utm_medium: "", utm_campaign: "", utm_content: "", utm_term: "", click_id: "", referrer_host: "" };
    String(search || "").replace(/^\?/, "").split("&").forEach(pair => {
      if (!pair) return;
      const i = pair.indexOf("=");
      let k = "", v = "";
      try {
        k = decodeURIComponent((i < 0 ? pair : pair.slice(0, i)).replace(/\+/g, " ")).toLowerCase();
        v = i < 0 ? "" : decodeURIComponent(pair.slice(i + 1).replace(/\+/g, " "));
      } catch { return; }
      if (Object.prototype.hasOwnProperty.call(out, k) && k.indexOf("utm_") === 0) out[k] = v.slice(0, 120);
      if (!out.click_id && /^(fbclid|gclid|ttclid|msclkid|sccid|epik)$/.test(k)) out.click_id = k;
    });
    try { if (referrer) out.referrer_host = new URL(referrer).hostname.replace(/^www\./, ""); } catch {}
    return out;
  }

  /* ================= browser controller ================= */
  function boot() {
    const win = window, doc = document;
    const host = doc.getElementById("nn-root"), tpl = doc.getElementById("nn-tpl");
    if (!host || !tpl || host.dataset.nnInit) return;
    host.dataset.nnInit = "1";
    /* Theme editor: inert, like the rest of the theme's popups when not selected. Preview it on the
       storefront with ?preview_theme_id=<id>&nn_popup=1. */
    if (win.Shopify && win.Shopify.designMode) return;

    const qa = new URLSearchParams(win.location.search).get("nn_popup") || "";
    const force = qa === "1", reset = qa === "reset";
    const themeRole = (win.Shopify && win.Shopify.theme && win.Shopify.theme.role) || "";
    const debug = (qa === "debug" || reset || force) && themeRole !== "main";
    const log = (...a) => { if (debug) { try { win.console.info("[nerm-nugs-popup]", ...a); } catch {} } };

    const d = host.dataset;
    const cfg = {
      country: (d.country || "US").toUpperCase(),
      pageType: d.pageType || d.template || "",
      keychain: d.keychain !== "false",
      plush: d.plush || "nerm",
      cssUrl: d.css,
      company: d.klaviyoCompany,
      listId: d.klaviyoList,
      smsListId: d.klaviyoSmsList || "",
      customSource: d.customSource || "Nerm Nugs Coming Soon Popup",
      gameUrl: d.gameUrl || "",
      /* Thank-you copy from Theme settings > Nerm Nugs popup. The fallbacks only cover a snippet without the attributes. */
      doneUs: d.doneUs !== undefined ? d.doneUs : "We'll text and email you the second Nerm Nugs drop. If it's your first time subscribing, your 10% off code is on its way.",
      doneIntl: d.doneIntl !== undefined ? d.doneIntl : "We'll email you the second Nerm Nugs drop. If it's your first time subscribing, your 10% off code is in your inbox.",
      loggedIn: d.loggedIn === "true",
      collector: d.collector === undefined ? COLLECTOR : d.collector,
      showAfterMs: 11000,      // ~11 s of visible engagement after the first scroll
      prefetchMs: 3000,        // warm CSS/images this long before the trigger
      dismissDays: 7,
      signupDays: 30
    };
    const reduceMotion = win.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const ss = { get: k => { try { return win.sessionStorage.getItem(k); } catch { return null; } },
                 set: (k, v) => { try { win.sessionStorage.setItem(k, v); } catch {} } };
    const ls = { get: k => { try { return win.localStorage.getItem(k); } catch { return null; } },
                 set: (k, v) => { try { win.localStorage.setItem(k, v); } catch {} },
                 del: k => { try { win.localStorage.removeItem(k); } catch {} } };
    const readState = () => { try { return JSON.parse(ls.get(STATE_KEY)) || {}; } catch { return {}; } };
    const writeState = patch => ls.set(STATE_KEY, JSON.stringify({ ...readState(), ...patch }));
    if (reset) { ls.del(STATE_KEY); ls.del(KNOWN_KEY); log("reset: caps and the Klaviyo known flag cleared"); }

    /* ---------------- analytics: same destinations and vocabulary as the Pocket Tee Popup ---------------- */
    const gate = { entry: "", pageviews: 0, via: "" };
    let queue = [], flushTimer = 0, flushHooks = false, elapsed = 0;
    const uuid = () => {
      try { if (win.crypto && win.crypto.randomUUID) return win.crypto.randomUUID(); } catch {}
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => { const r = Math.random() * 16 | 0; return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16); });
    };
    const cookieVal = name => { const v = readCookie(doc.cookie, name); try { return decodeURIComponent(v); } catch { return v; } };
    function landing() {
      const raw = ss.get(SS.landing);
      if (raw) { try { return JSON.parse(raw); } catch {} }
      const l = parseLanding(win.location.search, doc.referrer);
      l.landing_path = win.location.pathname;
      ss.set(SS.landing, JSON.stringify(l));
      return l;
    }
    function analyticsAllowed() {
      try {
        const cp = win.Shopify && win.Shopify.customerPrivacy;
        if (cp && typeof cp.analyticsProcessingAllowed === "function") return cp.analyticsProcessingAllowed() !== false;
      } catch {}
      return true;
    }
    function context() {
      let sid = ss.get(SS.sid); if (!sid) { sid = uuid(); ss.set(SS.sid, sid); }
      let vid = cookieVal("_shopify_y") || ls.get(LS.vid); if (!vid) { vid = uuid(); ls.set(LS.vid, vid); }
      let fine = false; try { fine = win.matchMedia("(hover: hover) and (pointer: fine)").matches; } catch {}
      let pageType = ""; try { pageType = win.ShopifyAnalytics.meta.page.pageType; } catch {}
      const c = {
        session_id: sid, visitor_id: vid, popup_version: VERSION, variant: VARIANT, trigger_via: gate.via,
        theme_id: (win.Shopify && win.Shopify.theme && win.Shopify.theme.id) || null, theme_role: themeRole,
        page_type: pageType || cfg.pageType, path: win.location.pathname,
        entry_type: gate.entry, pageviews: gate.pageviews || null,
        active_s: elapsed ? Math.round(elapsed / 1000) : null, depth_pct: null,
        device: fine ? "desktop" : "mobile", viewport_w: win.innerWidth,
        country: (win.Shopify && win.Shopify.country) || cfg.country, locale: (win.Shopify && win.Shopify.locale) || "",
        currency: (win.Shopify && win.Shopify.currency && win.Shopify.currency.active) || ""
      };
      return Object.assign(c, landing());
    }
    function flush(useBeacon) {
      if (flushTimer) { win.clearTimeout(flushTimer); flushTimer = 0; }
      if (!queue.length || !cfg.collector) return;
      const body = JSON.stringify({ v: 1, events: queue.splice(0, 50) });
      let sent = false;
      try { if (useBeacon !== false && win.navigator.sendBeacon) sent = win.navigator.sendBeacon(cfg.collector, new Blob([body], { type: "text/plain" })); } catch {}
      if (!sent) { try { win.fetch(cfg.collector, { method: "POST", body, keepalive: true, mode: "no-cors", headers: { "content-type": "text/plain" } }); } catch {} }
      if (queue.length) flush(useBeacon);
    }
    function track(name, props) {
      try { doc.dispatchEvent(new CustomEvent("ripndip:nn-popup", { detail: { name, country: cfg.country, ...(props || {}) } })); } catch {}
      if (!analyticsAllowed()) return;
      const ev = Object.assign(context(), { event: name, event_id: uuid(), ts: new Date().toISOString() }, props || {});
      queue.push(ev);
      if (!flushTimer) flushTimer = win.setTimeout(() => flush(true), 2000);
      if (!flushHooks) {
        flushHooks = true;
        win.addEventListener("pagehide", () => flush(true));
        doc.addEventListener("visibilitychange", () => { if (doc.visibilityState === "hidden") flush(true); });
      }
      try { if (win.posthog && win.posthog.capture) win.posthog.capture(name, ev); } catch {}
      try { if (win.Shopify && win.Shopify.analytics && win.Shopify.analytics.publish) win.Shopify.analytics.publish("pocket_popup", ev); } catch {}
      log(name, props || "");
    }
    /* Once per session: who this visitor was, as far as the signup popups are concerned. */
    function decision(audience, reason) {
      if (ss.get(SS.decided)) return;
      ss.set(SS.decided, "1");
      track("pp_session_decision", { audience, reason: reason || "" });
    }
    function setCartAttributes(attrs) {
      try { win.fetch("/cart/update.js", { method: "POST", credentials: "same-origin", headers: { "content-type": "application/json" }, body: JSON.stringify({ attributes: attrs }) }).catch(() => {}); } catch {}
    }
    const today = () => new Date().toISOString().slice(0, 10);
    function stampKlaviyo(email, phoneNumber) {
      const c = context();
      const props = { pp_variant: VARIANT, pp_version: VERSION, pp_trigger: gate.via, pp_signup_path: c.path, pp_signup_page_type: c.page_type,
        pp_entry_type: c.entry_type, pp_landing_path: c.landing_path || "", pp_utm_source: c.utm_source, pp_utm_medium: c.utm_medium,
        pp_utm_campaign: c.utm_campaign, pp_referrer_host: c.referrer_host, pp_device: c.device, pp_session_id: c.session_id, pp_signup_date: today(),
        nn_sms_opted_in: !!phoneNumber };
      try {
        const k = win.klaviyo;
        const id = Object.assign({ email }, phoneNumber ? { phone_number: phoneNumber } : {}, props);
        if (k && typeof k.identify === "function") {
          const r = k.identify(id);
          const send = () => { try { k.track("Nerm Nugs Popup Signup", props); } catch {} };
          if (r && typeof r.then === "function") r.then(send, send); else send();
        } else if (k && typeof k.push === "function") {
          k.push(["identify", Object.assign({ $email: email }, props)]);
          k.push(["track", "Nerm Nugs Popup Signup", props]);
        }
      } catch {}
    }

    /* ---------------- bookkeeping on every pageview, including ones we skip (same keys as the gate) ---------------- */
    const pageviews = (parseInt(ss.get(SS.pv), 10) || 0) + 1;
    ss.set(SS.pv, String(pageviews));
    let pageType = cfg.pageType; try { pageType = win.ShopifyAnalytics.meta.page.pageType || pageType; } catch {}
    const path = win.location.pathname;
    let entry = ss.get(SS.entry);
    if (pageviews === 1 || !entry) { entry = blockedPage(path, pageType) === "product" ? "product" : "other"; ss.set(SS.entry, entry); }
    if (ownedChannelLanding(win.location.search)) ls.set(LS.owned, "1");
    gate.entry = entry; gate.pageviews = pageviews;

    /* ---------------- state shared by the trigger and the popup ---------------- */
    let audience = "pending", fired = false, usStatus = cfg.country === "US" ? "pending" : "other", countryReq = null;
    let overlay, card, toy, canvas, ctx, charm, charmImg, hint, plush, lastFocus = null, phone = "", signedUp = false, step = "", openedAt = 0, releasedAt = 0, emailFocused = false;
    const $ = s => host.querySelector(s);

    /* ---------------- audience: who ---------------- */
    function known() {
      if (ls.get(KNOWN_KEY)) return true;
      if (linkKnown(win.location.search)) return true;
      let b64 = null; try { if (typeof win.atob === "function") b64 = t => win.atob(t); } catch {}
      return cookieKnown(readCookie(doc.cookie, "__kla_id"), b64);
    }
    /* window.klaviyo is an array-shaped queue until klaviyo.js (loaded by the Klaviyo app embed) swaps in the
       real object, so poll briefly for isIdentified, then give up and report "not known" rather than holding
       the popup shut. */
    function askIdentified(cb) {
      let done = false;
      const finish = v => { if (!done) { done = true; cb(!!v); } };
      const attempt = () => {
        try {
          const k = win.klaviyo;
          if (!k || typeof k.isIdentified !== "function") return false;
          const r = k.isIdentified();
          if (r && typeof r.then === "function") r.then(finish, () => finish(false)); else finish(r);
          return true;
        } catch { finish(false); return true; }
      };
      if (attempt()) return;
      let waited = 0;
      const iv = win.setInterval(() => { waited += 100; if (attempt() || waited >= PROBE_MS) { win.clearInterval(iv); if (!done) finish(false); } }, 100);
      win.setTimeout(() => finish(false), PROBE_MS + 400);
    }
    function marketingDenied() {
      try {
        const cp = win.Shopify && win.Shopify.customerPrivacy;
        const fn = cp && (cp.marketingAllowed || cp.firstPartyMarketingAllowed);
        return typeof fn === "function" && fn.call(cp) === false;
      } catch { return false; }
    }
    function busy() {
      if (drawerOpen(doc.documentElement.className) || (doc.body && drawerOpen(doc.body.className))) return true;
      const a = doc.activeElement;
      return !!(a && a !== doc.body && /^(?:INPUT|TEXTAREA|SELECT)$/.test(a.tagName));
    }
    function cartHasItems() {
      try {
        return win.fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json()).then(c => !!(c && c.item_count > 0)).catch(() => false);
      } catch { return Promise.resolve(false); }
    }
    /* Visitor location, confirmed against what Shopify detected rather than the market in the URL. Fails
       closed: an unconfirmed visitor gets the email-only flow, because a US-only TCPA disclosure shown to
       someone abroad is worse than a lost SMS opt-in. */
    function confirmCountry() {
      if (usStatus !== "pending" || countryReq) return;
      try {
        countryReq = win.fetch("/browsing_context_suggestions.json", { credentials: "same-origin" })
          .then(r => r.json())
          .then(data => { const h = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle; usStatus = String(h || "").toUpperCase() === "US" ? "us" : "other"; })
          .catch(() => { usStatus = "other"; });
      } catch { usStatus = "other"; }
    }
    const countryKnown = ms => new Promise(resolve => {
      if (usStatus !== "pending") return resolve();
      confirmCountry();
      const t0 = Date.now();
      const iv = win.setInterval(() => { if (usStatus !== "pending" || Date.now() - t0 > ms) { win.clearInterval(iv); resolve(); } }, 50);
    });

    /* ---------------- lazy load: CSS + template + images ---------------- */
    let ready = null;
    function load() {
      if (ready) return ready;
      confirmCountry();
      ready = new Promise((resolve, reject) => {
        const link = doc.createElement("link");
        link.rel = "stylesheet"; link.href = cfg.cssUrl;
        link.onload = resolve; link.onerror = reject;
        doc.head.appendChild(link);
      }).then(() => {
        const fur = /url\(['"]?([^'")]+)/.exec(host.style.getPropertyValue("--nn-fur"));
        if (fur) new Image().src = fur[1];   // warm the background so it is there on first paint
        host.appendChild(tpl.content.cloneNode(true));
        host.hidden = false;
        init();
      });
      return ready;
    }
    function release(via) {
      if (fired) return;
      fired = true; gate.via = via; releasedAt = Date.now();
      track("pp_triggered", { via, page_ms: Math.round(elapsed) || null });
      load().then(open).catch(e => log("load failed", e));
    }

    /* ---------------- the flow for this pageview ---------------- */
    if (force) { audience = "ok"; log("forced open (?nn_popup=1)"); release("now"); }
    else {
      const now = Date.now();
      if (!reset) {
        const cap = capped(readState(), now, cfg.dismissDays, cfg.signupDays);
        if (cap) { log("skip: capped,", cap); decision("skipped", "suppressed"); return; }
        const until = pocketSuppressedUntil(doc.cookie);
        if (until && now < until) { log("skip: the Pocket Tee Popup owns this browser until", new Date(until)); decision("skipped", "suppressed"); return; }
        if (cfg.loggedIn) { log("skip: logged-in customer"); decision("skipped", "logged-in"); return; }
        if (ls.get(LS.buyer) || /(?:^|; )rnd_buyer=1/.test(doc.cookie || "")) { log("skip: previous buyer"); decision("skipped", "previous-buyer"); return; }
        if (ls.get(LS.owned)) { log("skip: email/sms traffic"); decision("skipped", "owned-channel"); return; }
        if (known()) { log("skip: klaviyo known"); decision("skipped", "klaviyo-known"); return; }
      }
      const blocked = reset ? "" : blockedPage(path, pageType);
      const entryOk = reset || entryAllows(entry, pageviews);
      if (reset) { audience = "ok"; decision("eligible", "reset"); }
      else {
        askIdentified(identified => {
          if (identified) { ls.set(KNOWN_KEY, "1"); audience = "klaviyo-identified"; log("skip: klaviyo identified"); decision("skipped", "klaviyo-identified"); }
          else { audience = "ok"; decision("eligible", ""); }
        });
      }
      if (blocked) { log("no popup on this page:", blocked); return; }
      if (!entryOk) { log("product-page entrance: waiting for pageview", PRODUCT_ENTRY_MIN_PAGEVIEWS, "(now", pageviews + ")"); return; }

      /* Trigger: ~11 s of visible time, counted from the first scroll. One passive listener until then. */
      let started = false, last = 0, consentWaits = 0;
      const attempt = () => {
        if (fired) return;
        if (audience === "pending" || busy()) { win.setTimeout(attempt, 500); return; }
        if (audience !== "ok") return;
        if (capped(readState(), Date.now(), cfg.dismissDays, cfg.signupDays)) return;
        /* An explicit "no" to marketing cookies is honoured; "not answered yet" (opt-in regions) is retried
           for two minutes, so someone who accepts the banner late still gets the popup. */
        if (!reset && marketingDenied()) {
          if (consentWaits++ < 60) { win.setTimeout(attempt, 2000); return; }
          log("hold: marketing consent declined"); return;
        }
        if (reset) { release("engaged"); return; }
        /* Shopper with a cart is mid-purchase: never stand between them and checkout. */
        cartHasItems().then(has => {
          if (has) { log("hold: cart has items"); track("pp_held", { reason: "cart", via: "engaged" }); return; }
          release("engaged");
        });
      };
      const tick = () => {
        if (doc.hidden) { last = performance.now(); win.setTimeout(tick, 500); return; }
        const t = performance.now(); elapsed += t - last; last = t;
        if (elapsed >= cfg.showAfterMs - cfg.prefetchMs) load().catch(() => {});
        if (elapsed >= cfg.showAfterMs) {
          "requestIdleCallback" in win ? win.requestIdleCallback(attempt, { timeout: 1500 }) : win.setTimeout(attempt, 0);
          return;
        }
        win.setTimeout(tick, 500);
      };
      const onScroll = () => {
        if (started) return;
        started = true; last = performance.now();
        win.removeEventListener("scroll", onScroll);
        win.setTimeout(tick, 500);
      };
      win.addEventListener("scroll", onScroll, { passive: true });
    }

    /* ================= everything below runs only after load() ================= */
    function init() {
      overlay = $("#nn"); card = $("#nn-card"); toy = $("#nn-toy"); canvas = $("#nn-chain");
      ctx = canvas.getContext("2d"); charm = $("#nn-charm"); charmImg = $("#nn-charm-img"); hint = $("#nn-hint");
      overlay.classList.toggle("nn--toy", cfg.keychain);
      if (cfg.keychain) {
        let plushes = {};
        try { plushes = JSON.parse(doc.getElementById("nn-plushes").textContent); } catch {}
        plush = plushes[cfg.plush] || plushes.nerm;
        if (plush) charmImg.src = plush.src; else overlay.classList.remove("nn--toy");
      }
      const game = $("#nn-game-link");
      if (cfg.gameUrl) { game.href = cfg.gameUrl; game.hidden = false; }

      overlay.addEventListener("click", e => {
        const el = e.target.closest("[data-nn-close]");
        if (!el) return;
        close(el.classList.contains("nn-x") ? "close-button" : el.classList.contains("nn-scrim") ? "overlay" : step === "done" ? "keep-shopping" : "no-thanks");
      });
      $("#nn-form-phone").addEventListener("submit", onPhone);
      $("#nn-form-email").addEventListener("submit", onEmail);
      $("#nn-email").addEventListener("focus", () => { if (!emailFocused) { emailFocused = true; track("pp_email_focus"); } });
      doc.addEventListener("keydown", onKey);
      doc.addEventListener("visibilitychange", () => { if (doc.hidden) stopSim(); else if (overlay && !overlay.hidden) startSim(); });
      if (plush) initToy();
    }

    /* Pandectes writes `display:block !important` as an INLINE style on <pandectes-cmp>, so no stylesheet
       can sequence the two. Overwrite the inline property while we are open, hold it (the banner
       re-asserts itself), and put back exactly what it had on close. Same approach as the Pocket Tee Popup. */
    let cmpSaved = null, cmpHold = 0;
    function suppressBanner() {
      const el = doc.querySelector("pandectes-cmp");
      if (!el) return;
      if (cmpSaved === null) cmpSaved = el.getAttribute("style") || "";
      if (el.style.display !== "none") el.style.setProperty("display", "none", "important");
    }
    function releaseBanner() {
      if (cmpHold) { win.clearInterval(cmpHold); cmpHold = 0; }
      const el = doc.querySelector("pandectes-cmp");
      if (el) { if (cmpSaved !== null) el.setAttribute("style", cmpSaved); else el.style.removeProperty("display"); }
      cmpSaved = null;
    }

    /* ---------------- open / close ---------------- */
    async function open() {
      if (!overlay || !overlay.hidden) return;
      await countryKnown(1500);
      const isUS = usStatus === "us";
      overlay.classList.toggle("nn--intl", !isUS);
      lastFocus = doc.activeElement;
      const first = isUS ? "phone" : "email";
      show(first);
      overlay.hidden = false;
      doc.documentElement.classList.add("nn-lock");
      try { suppressBanner(); cmpHold = win.setInterval(suppressBanner, 300); } catch {}
      openedAt = Date.now();
      writeState({ shownAt: openedAt });
      track("pp_shown", { ms_to_open: releasedAt ? openedAt - releasedAt : null });
      setCartAttributes({ _pp_exposed: VARIANT + "|" + today() });
      track(first === "phone" ? "pp_sms_viewed" : "pp_capture_viewed", first === "phone" ? {} : { path: "direct" });
      if (plush && overlay.classList.contains("nn--toy")) {
        hint.textContent = win.matchMedia("(pointer: coarse)").matches ? "Swipe him to swing" : "Grab him and swing";
        requestAnimationFrame(() => { layout(false); render(); startSim(); });
      }
      win.setTimeout(() => card.focus({ preventScroll: true }), 50);
    }
    function close(method) {
      if (!overlay || overlay.hidden) return;
      const openMs = openedAt ? Date.now() - openedAt : null;
      if (!signedUp) { writeState({ dismissedAt: Date.now() }); track("pp_dismissed", { from_state: step, method: method || "unknown", open_ms: openMs }); }
      else track("pp_closed", { final_state: step, open_ms: openMs });
      overlay.classList.add("is-closing");
      stopSim();
      win.setTimeout(() => {
        overlay.hidden = true; overlay.classList.remove("is-closing");
        doc.documentElement.classList.remove("nn-lock");
        releaseBanner();
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
        flush(true);
      }, reduceMotion ? 0 : 230);
    }
    function onKey(e) {
      if (!overlay || overlay.hidden) return;
      if (e.key === "Escape") { close("escape"); return; }
      if (e.key !== "Tab") return;
      const f = [...card.querySelectorAll("button,input,a[href],[tabindex='0']")].filter(el => !el.closest("[hidden]") && !el.disabled && el.offsetParent !== null);
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* ---------------- steps + Klaviyo ---------------- */
    function show(s) {
      step = s;
      host.querySelectorAll(".nn-step").forEach(el => (el.hidden = el.dataset.step !== s));
      card.setAttribute("aria-labelledby", "nn-h-" + s);
    }
    function go(s) {
      show(s);
      const target = s === "phone" ? $("#nn-phone") : s === "email" ? $("#nn-email") : $("#nn-h-done");
      win.setTimeout(() => target.focus({ preventScroll: true }), 60);
    }
    function showError(input, msg) {
      const err = host.querySelector("#" + input.getAttribute("aria-describedby"));
      input.setAttribute("aria-invalid", msg ? "true" : "false");
      err.textContent = msg || ""; err.hidden = !msg;
      if (msg) input.focus();
    }
    /* Same endpoint, API revision and payload shape as the Pocket Tee Popup (assets/pocket-pull-engine.js). */
    async function subscribe(profile) {
      const res = await win.fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(cfg.company), {
        method: "POST",
        headers: { "content-type": "application/json", revision: "2026-07-15" },
        body: JSON.stringify(subscribePayload(profile, cfg.listId, cfg.customSource, cfg.smsListId))
      });
      return classifyResponse(res.status);
    }
    async function send(form, input, profile, kind) {
      const btn = form.querySelector(".nn-btn"), label = btn.textContent;
      btn.disabled = true; btn.textContent = "Sending…";
      let verdict;
      try { verdict = await subscribe(profile); } catch { verdict = "error"; }
      finally { btn.disabled = false; btn.textContent = label; }
      if (verdict === "success") return true;
      /* The field is never cleared on failure. Making someone retype is how you lose the capture. */
      const msg = verdict === "invalid" ? (kind === "sms" ? "That number doesn't look right." : "That email doesn't look right.")
        : verdict === "retry" ? "Too many tries. Give it a moment and try again."
        : "That didn't go through. Check your connection and try again.";
      showError(input, msg);
      track(kind === "sms" ? "pp_sms_error" : "pp_email_error", { message: msg.slice(0, 80) });
      return false;
    }
    async function onPhone(e) {
      e.preventDefault();
      const el = $("#nn-phone"), raw = el.value.trim();
      const e164 = toE164US(raw);
      if (!e164) return showError(el, raw ? "Enter your US mobile number with area code, like (555) 234-5678." : "Add your mobile number to get 10% off.");
      showError(el, "");
      phone = e164;
      track("pp_sms_submit");
      if (await send(e.target, el, { phone_number: phone }, "sms")) {
        track("pp_sms_success");
        go("email");
        track("pp_capture_viewed", { path: "phone" });
      }
    }
    async function onEmail(e) {
      e.preventDefault();
      const el = $("#nn-email"), v = el.value.trim();
      const valid = isValidEmail(v);
      track("pp_email_submit", { valid });
      if (!valid) return showError(el, v ? "Enter an email address like name@example.com." : "Add your email to get 10% off.");
      showError(el, "");
      const profile = usStatus === "us" && phone ? { email: v, phone_number: phone } : { email: v };
      if (await send(e.target, el, profile, "email")) {
        signedUp = true; writeState({ signedUpAt: Date.now() });
        track("pp_email_success", { open_ms: openedAt ? Date.now() - openedAt : null });
        setCartAttributes({ _pp_signup: VARIANT + "|" + gate.via + "|" + today(), _pp_sid: context().session_id });
        stampKlaviyo(v, profile.phone_number || "");
        $("#nn-done-copy").textContent = usStatus === "us" ? cfg.doneUs : cfg.doneIntl;
        go("done");
        track("pp_done");
        if (plush) kick(S.h * 2.5);
      }
    }

    /* =============== keychain physics ===============
       Two-point rigid body on a rope: A = where the chain meets the plush, C = the plush's center of mass.
       Rope P→A has a max length (can go slack); A→C is a rigid rod. Verlet integration + constraint relaxation. */
    const S = { W: 0, H: 0, dpr: 1, w: 0, h: 0, L: 0, r: 0, P: { x: 0, y: 0 },
      A: { x: 0, y: 0, px: 0, py: 0 }, C: { x: 0, y: 0, px: 0, py: 0 },
      grabbed: false, grabOff: { x: 0, y: 0 }, target: { x: 0, y: 0 }, lastTarget: { x: 0, y: 0 }, raf: 0, t: 0, last: 0, running: false };
    const G = 2600, DAMP = 0.9986, SUB = 6;

    function layout(keepPose) {
      const W = toy.clientWidth, H = toy.clientHeight;
      if (!W || !H) return;
      S.dpr = Math.min(2, win.devicePixelRatio || 1);
      canvas.width = Math.round(W * S.dpr); canvas.height = Math.round(H * S.dpr);
      const sx = keepPose && S.W ? W / S.W : 1;
      S.W = W; S.H = H;
      S.h = Math.round(H * 0.74); S.w = S.h * plush.ar;
      charm.style.width = S.w + "px"; charm.style.height = S.h + "px";
      S.L = H * 0.12; S.r = S.h * 0.56; S.P = { x: W / 2, y: -2 };
      if (!keepPose) setPose(reduceMotion ? 0 : 7);   // a few degrees off plumb: a gentle sway on open, not a full swing
      else for (const p of [S.A, S.C]) { p.x *= sx; p.px = p.x; p.py = p.y; }
    }
    function setPose(deg) {
      const a = deg * Math.PI / 180, dx = Math.sin(a), dy = Math.cos(a);
      S.A.x = S.A.px = S.P.x + dx * S.L; S.A.y = S.A.py = S.P.y + dy * S.L;
      S.C.x = S.C.px = S.A.x + dx * S.r; S.C.y = S.C.py = S.A.y + dy * S.r;
    }
    function integrate(p, ax, ay, dt) {
      let vx = (p.x - p.px) * DAMP, vy = (p.y - p.py) * DAMP;
      const sp = Math.hypot(vx, vy);
      if (sp > 60) { vx *= 60 / sp; vy *= 60 / sp; }
      p.px = p.x; p.py = p.y; p.x += vx + ax * dt * dt; p.y += vy + ay * dt * dt;
    }
    function relax() {
      const { A, C, P, L, r } = S;
      for (let k = 0; k < 8; k++) {
        let dx = A.x - P.x, dy = A.y - P.y, d = Math.hypot(dx, dy);
        if (d > L) { A.x = P.x + dx / d * L; A.y = P.y + dy / d * L; }
        dx = C.x - A.x; dy = C.y - A.y; d = Math.hypot(dx, dy) || 1e-4;
        const diff = (d - r) / d, wA = S.grabbed ? 1 : 0.86, wC = S.grabbed ? 0 : 0.14;
        A.x += dx * diff * wA; A.y += dy * diff * wA; C.x -= dx * diff * wC; C.y -= dy * diff * wC;
      }
    }
    function stepSim(dt) {
      const sdt = dt / SUB;
      const wind = reduceMotion || S.grabbed ? 0 : Math.sin(S.t * 0.8) * Math.sin(S.t * 0.37 + 1) * 120;
      for (let i = 0; i < SUB; i++) {
        if (S.grabbed) {
          const f = (i + 1) / SUB;
          S.C.px = S.C.x; S.C.py = S.C.y;
          S.C.x = S.lastTarget.x + (S.target.x - S.lastTarget.x) * f;
          S.C.y = S.lastTarget.y + (S.target.y - S.lastTarget.y) * f;
        } else integrate(S.C, wind, G, sdt);
        integrate(S.A, 0, G, sdt);
        relax();
        if (!S.grabbed && Math.abs(Math.atan2(S.C.x - S.P.x, S.C.y - S.P.y)) > 1.9) { // swing, never loop
          S.C.px = S.C.x - (S.C.x - S.C.px) * 0.82; S.C.py = S.C.y - (S.C.y - S.C.py) * 0.82;
        }
      }
      S.lastTarget.x = S.target.x; S.lastTarget.y = S.target.y;
    }
    function clampTarget(x, y) {
      const reach = S.L + S.r, dx = x - S.P.x, dy = y - S.P.y, d = Math.hypot(dx, dy);
      if (d > reach) { x = S.P.x + dx / d * reach; y = S.P.y + dy / d * reach; }
      const m = S.w * 0.55;
      return { x: Math.min(S.W - m, Math.max(m, x)), y: Math.max(S.h * 0.2, y) };
    }
    function drawChain() {
      const { P, A, L, dpr } = S;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, S.W, S.H);
      const d = Math.hypot(A.x - P.x, A.y - P.y), sag = d < L ? Math.sqrt(L * L - d * d) * 0.6 : 0;
      const qx = (P.x + A.x) / 2, qy = (P.y + A.y) / 2 + sag, pts = [{ x: P.x, y: P.y, len: 0 }];
      for (let i = 1; i <= 40; i++) {
        const t = i / 40, u = 1 - t, x = u * u * P.x + 2 * u * t * qx + t * t * A.x, y = u * u * P.y + 2 * u * t * qy + t * t * A.y, prev = pts[i - 1];
        pts.push({ x, y, len: prev.len + Math.hypot(x - prev.x, y - prev.y) });
      }
      const total = pts[pts.length - 1].len, k = S.h / 300, gap = 6.2 * k, rx = 2.9 * k, ry = 3.9 * k;
      let j = 1, n = 0;
      for (let s = 0; s <= total; s += gap, n++) {
        while (j < pts.length - 1 && pts[j].len < s) j++;
        const a = pts[j - 1], b = pts[j], f = (s - a.len) / (b.len - a.len || 1);
        ctx.save(); ctx.translate(a.x + (b.x - a.x) * f, a.y + (b.y - a.y) * f); ctx.rotate(Math.atan2(b.y - a.y, b.x - a.x) - Math.PI / 2);
        if (n % 2 === 0) {
          ctx.beginPath(); ctx.ellipse(0, 0, rx, ry, 0, 0, Math.PI * 2); ctx.lineWidth = 1.7 * k; ctx.strokeStyle = plush.chain; ctx.stroke();
          ctx.beginPath(); ctx.ellipse(-0.5 * k, -0.6 * k, rx * 0.62, ry * 0.7, 0, Math.PI * 1.05, Math.PI * 1.75); ctx.lineWidth = 0.7 * k; ctx.strokeStyle = "rgba(255,255,255,.6)"; ctx.stroke();
        } else {
          ctx.beginPath(); ctx.moveTo(0, -ry * 1.05); ctx.lineTo(0, ry * 1.05); ctx.lineCap = "round"; ctx.lineWidth = 1.9 * k; ctx.strokeStyle = plush.chain; ctx.stroke();
        }
        ctx.restore();
      }
    }
    function render() {
      const { A, C } = S, ang = Math.atan2(-(C.x - A.x), C.y - A.y), ox = plush.cx * S.w, oy = 2;
      charm.style.transformOrigin = `${ox}px ${oy}px`;
      charm.style.transform = `translate(${A.x - ox}px, ${A.y - oy}px) rotate(${ang}rad)`;
      drawChain();
    }
    function frame(now) {
      const dt = Math.min(1 / 30, (now - S.last) / 1000 || 1 / 60);
      S.last = now; S.t += dt; stepSim(dt); render();
      if (S.running) S.raf = requestAnimationFrame(frame);
    }
    function startSim() {
      if (!plush || !overlay || overlay.hidden || doc.hidden || !overlay.classList.contains("nn--toy")) return;
      cancelAnimationFrame(S.raf); S.running = true; S.last = performance.now(); S.raf = requestAnimationFrame(frame);
    }
    function stopSim() { S.running = false; cancelAnimationFrame(S.raf); }
    function kick(vx, vy = 0) { const f = 1 / (60 * SUB); S.C.px -= vx * f; S.C.py -= vy * f; }
    let playTracked = false;
    const played = () => { toy.classList.add("has-played"); if (!playTracked) { playTracked = true; track("pp_keychain_play"); } };

    function initToy() {
      const local = e => { const r = toy.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
      charm.addEventListener("pointerdown", e => {
        if (e.button !== 0) return;
        e.preventDefault();
        const p = local(e);
        S.grabOff = { x: S.C.x - p.x, y: S.C.y - p.y };
        S.target = clampTarget(p.x + S.grabOff.x, p.y + S.grabOff.y); S.lastTarget = { x: S.C.x, y: S.C.y };
        S.grabbed = true; charm.classList.add("is-grabbed"); played();
        charm.setPointerCapture(e.pointerId);
      });
      charm.addEventListener("pointermove", e => { if (S.grabbed) { const p = local(e); S.target = clampTarget(p.x + S.grabOff.x, p.y + S.grabOff.y); } });
      const drop = () => { if (!S.grabbed) return; S.grabbed = false; charm.classList.remove("is-grabbed"); };
      ["pointerup", "pointercancel", "lostpointercapture"].forEach(t => charm.addEventListener(t, drop));
      let swipe = null;   // a quick swipe in the empty space around him flicks him too
      toy.addEventListener("pointerdown", e => { if (charm.contains(e.target)) return; swipe = { ...local(e), t: performance.now() }; });
      toy.addEventListener("pointerup", e => {
        if (!swipe) return;
        const p = local(e), vx = (p.x - swipe.x) / Math.max(16, performance.now() - swipe.t);
        if (Math.abs(vx) > 0.25) { kick(Math.max(-850, Math.min(850, vx * 700))); played(); }
        swipe = null;
      });
      charm.addEventListener("keydown", e => {
        if (e.key === "ArrowLeft") { e.preventDefault(); kick(-S.h * 3); played(); }
        if (e.key === "ArrowRight") { e.preventDefault(); kick(S.h * 3); played(); }
      });
      if ("ResizeObserver" in win) new ResizeObserver(() => { if (!overlay.hidden && toy.clientWidth) layout(true); }).observe(toy);
    }
  }

  if (typeof document !== "undefined") {
    try { boot(); } catch (e) { try { console.error("[nerm-nugs-popup]", e); } catch {} }
  }

  return { VERSION, VARIANT, KNOWN_KEY, STATE_KEY, PRODUCT_ENTRY_MIN_PAGEVIEWS, readCookie, cookieKnown, linkKnown, ownedChannelLanding,
    blockedPage, entryAllows, drawerOpen, pocketSuppressedUntil, capped, toE164US, isValidEmail, classifyResponse, subscribePayload, parseLanding };
});
